// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3HBfb","left":"StickyBox_left__2cxZS","right":"StickyBox_right__2BG_F"};